import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import * as _ from "lodash";
import { Request } from "./request";
import { URLS } from "../constants/url.constants";
import { map } from "rxjs/operators";
import { HttpClient, HttpHeaders, HttpRequest } from "@angular/common/http";

@Injectable({
  providedIn: "root",
})
export class ProviderService {
  constructor(
    private request: Request,
    private http: HttpClient,
  ) {
  }


  getProvidersList(event): Observable<any> {


    if (event.direction == 'desc') {
      event.direction = 2;
    }
    else {
      event.direction = 1;
    }

    if (!event.searchkey) {
      event.searchkey = '';
    }
    if (!event.favourites) {
      event.favourites = '';
    }
    if (!event.secondary) {
      event.secondary = '';
    }

    let url = URLS.provider.getProvidersList + '?limit=' + event.pageSize + '&page=' + (event.pageIndex + 1) + '&searchkey=' + event.searchkey + '&order_by=' + event.active + '&dir=' + event.direction + '&secondary=' + event.secondary + '&favourites=' + event.favourites;
    return this.request.getApi(url);
  }


  getProvidersFullList(): Observable<any> {

    let url = URLS.provider.getProvidersFullList;
    return this.request.getApi(url);
  }

  saveProviders(values): Observable<any> {
    let url = URLS.provider.saveProviders;
    return this.request.postApi(url, values);
  }

  getAutoCompleteProvidersList(val, listFor?: string): Observable<any> {

    let url = URLS.provider.getProvidersFullList + '?searchkey=' + val + '&listFor=' + listFor;
    return this.request.getApi(url);
  }


  getAutoCompleteDoctorsList(val, speciality, listFor?: string): Observable<any> {

    let url = URLS.provider.getProvidersList + '?searchkey=' + val + '&withspeciality=' + speciality + '&limit=20&listFor=' + listFor;
    return this.request.getApi(url);
  }

  editProviders(id, values): Observable<any> {
    let url = URLS.provider.editDeleteProviders;
    url = _.replace(url, "{id}", id);
    return this.request.putApi(url, values);
  }

  deleteProviders(data): Observable<any> {
    let url = URLS.provider.editDeleteProviders;
    url = _.replace(url, "{id}", data.id);
    return this.request.deleteApi(url);
  }

  PatchProviders(data): Observable<any> {
    let url = URLS.provider.editDeleteProviders;
    url = _.replace(url, "{id}", data.provider_id);
    return this.request.patchApi(url, data);
  }

  getProvidersInfo(id, cdate?: any, listFor?: string): Observable<any> {
    let url = URLS.provider.editDeleteProviders + '?cdate=' + cdate + '&listFor=' + listFor;
    url = _.replace(url, "{id}", id);
    return this.request.getApi(url);
  }



  getProvidersProfile(uid?: any): Observable<any> {
    let url = URLS.provider.providerinfo + '?user_id=' + uid;
    return this.request.getApi(url);
  }

  getProvidersInfo_byUserId(uid): Observable<any> {
    let url = URLS.provider.getProvidersList + '?user_id=' + uid;
    return this.request.getApi(url);
  }


  saveUnavailability(values): Observable<any> {
    let url = URLS.unavailability.saveUnavailability;
    return this.request.postApi(url, values);
  }



  getUnavailabilityList(event): Observable<any> {


    if (event.direction == 'desc') {
      event.direction = 2;
    }
    else {
      event.direction = 1;
    }

    let url = URLS.unavailability.getUnavailabilityList + '?limit=' + event.pageSize + '&page=' + (event.pageIndex + 1) + '&searchkey=' + event.searchkey + '&order_by=' + event.active + '&dir=' + event.direction + '&from=' + event.fromdate + '&to=' + event.todate + '&user_id=' + event.user_id;
    return this.request.getApi(url);
  }


  deleteUnavailability(id): Observable<any> {

    let url = URLS.unavailability.editDeleteUnavailability;
    url = _.replace(url, "{id}", id);
    return this.request.deleteApi(url);
  }



  saveCustomizedavailability(values): Observable<any> {
    let url = URLS.customizedAvailability.saveCustomizedavailability;
    return this.request.postApi(url, values);
  }



  getCustomizedavailabilityList(event): Observable<any> {


    if (event.direction == 'desc') {
      event.direction = 2;
    }
    else {
      event.direction = 1;
    }

    let url = URLS.customizedAvailability.getCustomizedavailabilityList + '?limit=' + event.pageSize + '&page=' + (event.pageIndex + 1) + '&searchkey=' + event.searchkey + '&order_by=' + event.active + '&dir=' + event.direction + '&from=' + event.fromdate + '&to=' + event.todate + '&user_id=' + event.user_id;
    return this.request.getApi(url);
  }


  deleteCustomizedavailability(id): Observable<any> {

    let url = URLS.customizedAvailability.editDeleteCustomizedavailability;
    url = _.replace(url, "{id}", id);
    return this.request.deleteApi(url);
  }
}
